
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SequenceDetailsGrid extends _Ext.GridBase<SequenceDetailsRow, any> {
        protected getColumnsKey() { return 'Administration.SequenceDetails'; }
        protected getDialogType() { return SequenceDetailsDialog; }
        protected getIdProperty() { return SequenceDetailsRow.idProperty; }
        protected getInsertPermission() { return SequenceDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return SequenceDetailsRow.localTextPrefix; }
        protected getService() { return SequenceDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}